var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", { staticClass: "section-padding" }, [
    _c("div", { staticClass: "row" }, [
      _c(
        "div",
        { staticClass: "col-12 text-center" },
        [
          _vm.errorMessage && !_vm.paymentSuccess
            ? [
                _c("i", {
                  staticClass: "fal fa-times-circle fa-5x text-danger"
                }),
                _vm._v(" "),
                _c("h4", { staticClass: "mt-4" }, [
                  _vm._v(
                    _vm._s(_vm.$t("message.payment_method.payment_failure")) +
                      ": " +
                      _vm._s(_vm.errorMessage)
                  )
                ]),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "mt-4" },
                  [
                    _c(
                      "router-link",
                      {
                        staticClass: "btn btn-info btn-lg",
                        attrs: {
                          to: {
                            name: "Service Request Detail",
                            params: { id: _vm.serviceRequestId }
                          }
                        }
                      },
                      [
                        _vm._v(
                          "\n            " +
                            _vm._s(_vm.$t("message.booking.navigation.back")) +
                            "\n          "
                        )
                      ]
                    )
                  ],
                  1
                )
              ]
            : [
                _c("div", [
                  _c("i", {
                    staticClass: "fal fa-check-circle fa-5x text-success"
                  }),
                  _vm._v(" "),
                  _c("h3", { staticClass: "mt-4" }, [
                    _vm._v(
                      "\n            " +
                        _vm._s(
                          _vm.$t("message.payment_method.payment_success")
                        ) +
                        "\n          "
                    )
                  ]),
                  _vm._v(" "),
                  _vm.paymentSuccess
                    ? _c(
                        "div",
                        { staticClass: "mt-3" },
                        [
                          _c(
                            "router-link",
                            {
                              staticClass: "btn btn-info btn-lg",
                              attrs: {
                                to: {
                                  name: "Service Request Detail",
                                  params: { id: _vm.serviceRequestId }
                                }
                              }
                            },
                            [
                              _vm._v(
                                "\n              " +
                                  _vm._s(
                                    _vm.$t(
                                      "message.booking.complete_step.view_my_booking"
                                    )
                                  ) +
                                  "\n            "
                              )
                            ]
                          )
                        ],
                        1
                      )
                    : _vm._e()
                ])
              ]
        ],
        2
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-6a19cc50", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6a19cc50","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/payment/PaymentServiceRequestValidation.vue
// module id = 2194
// module chunks = 0